<script>
export default {
    name: 'BrandLogoTextboxEcolea',
}
</script>
<template>
    <svg
        class="base-brand brand-logo-textbox-ecolea"
        xmlns="http://www.w3.org/2000/svg"
        width="127"
        height="131"
        fill="none"
        viewBox="0 0 127 131"
    >
        <path
            fill="#e9455e"
            d="M101.162 66.034H71.678v5.785h29.484zM101.162 77.053H71.678v5.784h29.484zM101.162 88.001H71.678v5.785h29.484zM35.917 130.998V6.391h-1.9v124.607M1.952 130.998v-5.868h15.68v-10.294h5.046v16.162zM1.952 108.855v-17.05h4.882v11.238h3.147v-10.13h4.503v10.13h3.312v-11.35h4.882v17.162zM12.37 89.535C6.24 89.535 1.52 84.832 1.52 78.41c0-4.318 1.79-7.088 4.34-8.969l3.363 4.429c-1.465 1.22-2.442 2.603-2.442 4.65 0 2.99 2.442 5.038 5.48 5.038h.053c3.091 0 5.533-2.104 5.533-5.037 0-2.215-1.03-3.487-2.497-4.762l3.093-4.429c2.712 1.993 4.668 4.707 4.668 9.355.108 5.923-4.559 10.794-10.364 10.907-.11-.056-.271-.056-.38-.056M12.37 68.115c-6.022 0-10.851-4.926-10.851-11.405s4.773-11.346 10.743-11.346h.053c5.968 0 10.797 4.87 10.797 11.404s-4.774 11.349-10.743 11.349m.002-16.833c-3.038 0-5.644 2.215-5.644 5.424s2.552 5.37 5.535 5.37h.053c2.983 0 5.588-2.214 5.588-5.423 0-3.212-2.55-5.37-5.532-5.37M1.952 42.26v-5.867h15.68v-10.24h5.046V42.26zM1.952 23.605V6.61h4.882v11.238h3.147V7.663h4.503v10.185h3.312V6.444h4.882v17.16z"
        />
        <path
            fill="#e9455e"
            d="M10.091 118.987c-.217-2.103-1.247-3.1-2.93-2.989v1.881h-4.72v-4.871h3.96c3.905 0 5.479 1.992 5.534 5.593l-1.844.388zM0 101.384l2.008 1.77.16-6.143-2.115-2.383zM126.998 131h-5.549V40.53c0-19.158-14.953-34.746-33.334-34.746h-3.068c-18.38 0-33.332 15.588-33.332 34.746V131h-5.549V40.53C46.168 18.182 63.611 0 85.049 0h3.068C109.558 0 127 18.182 127 40.53V131z"
        />
        <path
            fill="#e9455e"
            d="M116.371 131h-5.549V41.546c0-13.635-10.641-24.727-23.72-24.727h-1.12c-13.08 0-23.72 11.092-23.72 24.727V131h-5.548V41.546c0-16.824 13.129-30.512 29.268-30.512h1.12c16.14 0 29.269 13.688 29.269 30.512z"
        />
        <path
            fill="#e9455e"
            d="M105.798 131h-5.549V42.066c0-7.83-6.109-14.2-13.62-14.2h-.175c-7.51 0-13.62 6.37-13.62 14.2V131h-5.549V42.066c0-11.018 8.599-19.984 19.169-19.984h.175c10.57 0 19.169 8.966 19.169 19.984z"
        />
    </svg>
</template>
